var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"available-products"},[_c('h3',[_vm._v("Available materials")]),_c('div',{staticClass:"products-list"},_vm._l((_vm.products),function(product,key){return _c('ProductCard',{attrs:{"product":product}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }